import React, { useState } from "react";
import { CustomerEdit, LocationEdit, DepartmentEdit } from "./";
import { CustomerPrices } from "../CustomerCreate";

const CustomerCreateForm = ({match}) => {
  const [formStep, setFormstep] = useState(0);
  const customerId = match.params.customerId;
  const [locationId, setLocationId] = useState();
  const stepTitle = {
    0: "Klant bewerken",
    1: "Locaties bewerken",
    2: "Afdelingen bewerken",
    3: "Maaltijdprijzen voor deze klant",
  };

  const _next = () => {
    if (formStep < 3) {
      setFormstep(formStep + 1);
    } else {
      console.log("return to customer overview");
    }
  };
  
  return (
    <div className="container">
      <h2 className="container__title">{stepTitle[formStep]}</h2>
      <div className="form__container">
        <div className="form__container__tabs">
          <span onClick={() => setFormstep(0)} className={"form__container__tabs__step"}>
            Stap1. Zorginstelling
          </span>
          <span onClick={() => setFormstep(1)} className="form__container__tabs__step">
            Stap2. Locatiegegevens
          </span>
          <span onClick={() => setFormstep(2)} className="form__container__tabs__step">
            Stap3. Afdelingsgegevens
          </span>
          <span onClick={() => setFormstep(3)} className="form__container__tabs__step">
            Stap4. Calculatie gegevens
          </span>
        </div>
        {formStep === 0 && (
          <CustomerEdit next={_next} customerId={customerId} />
        )}
        {formStep === 1 && (
          <LocationEdit
            next={_next}
            customerId={customerId}
            setLocationId={setLocationId}
          />
        )}
        {formStep === 2 && (
          <DepartmentEdit next={_next} customerId={customerId} />
        )}
        {formStep === 3 && (
          <CustomerPrices next={_next} edit="true" customerId={customerId} />
        )}
      </div>
    </div>
  );
};

export default CustomerCreateForm;
